<div class="message-templates-dialog">
    <div class="dialog-header">
      <span *ngIf="messageType === 'Email'">Message templates</span>
      <span *ngIf="messageType === 'Reminder'">Reminder templates</span>
    </div>
    <div class="import-dialog-content">
        <owc-input style="width: 100%;" variant="outlined" label="Subject" [formControl]="msgTemplateSubjectFormControl" (keyup)="onKeyupSubjectName($event)" (blur)="onBlurSubjectName($event)" min="5" max="255" />
      <dl-rich-text-document style="margin-top: 27px;" [jsonTextItem]="textDoc" [showInEditor]="" (jsonTextReturn)="setRTETextadd($event)"></dl-rich-text-document>
    </div>
    <div class="import-dialog-actions">
      <owc-button class="cancel-button" (click)="closeDialog.emit()">
        Cancel
      </owc-button>
      <owc-button color="primary" (click)="updateMsgTemplate()">
        Save
      </owc-button>
    </div>
  </div>
  